/**
 * Unlike turntoflow-check, this one is intended to be used with embedded-submission.
 * The idea is that there is no need to dynamically choose to load email-flow-entry.
 * It should be a given that it is there since it should be an embedded landing page.
 */
import { TurnToFlow } from './email-flows-common'
import { processTurntoflow } from './email-flow-entry'

export function checkTurntoflow(): void {
  const params = new URLSearchParams(document.location.search)
  const turntoflow = params.get('turntoflow') as TurnToFlow
  if (turntoflow) {
    processTurntoflow(turntoflow, params)
  }
}
